import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zoomin",
  "use": "icon-zoomin-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zoomin\"><path d=\"M426.496 740.58a256 256 0 100-512 256 256 0 000 512zm-28.274-285.47H343.95a28.444 28.444 0 000 56.889h54.272v56.889a28.444 28.444 0 0056.89 0V512h59.505a28.444 28.444 0 000-56.889H455.11v-56.889a28.444 28.444 0 00-56.889 0v56.89zm410.283 450.96L627.086 724.651a312.889 312.889 0 11-200.59-553.017 312.889 312.889 0 01240.754 512.74l181.475 181.475a28.444 28.444 0 01-40.22 40.22z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol